import { Reveal } from "./Reveal";

const RULES = [
  {
    num: "01",
    title: "Bring as many quarts as you like",
    body: "No quota, no pressure — whatever your pot makes. One quart heads to the tasting table so everyone gets a spoonful; the rest go into the swap.",
  },
  {
    num: "02",
    title: "Take home as many as you share",
    body: "Bring 5, take home 4. Bring 8, take home 7. Simple math, and nobody leaves without a freezer full of new favorites.",
  },
  {
    num: "03",
    title: "Freeze-friendly & fully labeled",
    body: "Sturdy, freezable, leak-proof containers only — and every quart gets the recipe name and FULL ingredient list taped on, so every allergy at the table stays safe.",
  },
];

export const Rules = () => (
  <section className="relative bg-[#C88F52] px-6 md:px-16 lg:px-24 py-24 md:py-36" data-testid="rules-section">
    <Reveal x={80}>
      <p className="font-body text-[11px] uppercase tracking-[0.35em] text-harvest mb-4">The House Rules</p>
      <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-tight text-cream">
        Three rules. <span className="font-accent text-harvest text-4xl md:text-6xl align-middle -rotate-2 inline-block">non-negotiable.</span>
      </h2>
    </Reveal>

    <div className="mt-16 md:mt-24">
      {RULES.map((rule, i) => (
        <Reveal key={rule.num} delay={i * 0.08}>
          <div className="grid grid-cols-12 gap-4 md:gap-8 border-t border-forest/30 py-10 md:py-14 items-start" data-testid={`rule-${rule.num}`}>
            <span className="col-span-3 md:col-span-2 font-display text-5xl md:text-8xl text-forest leading-none">
              {rule.num}
            </span>
            <div className="col-span-9 md:col-span-6 md:col-start-5">
              <h3 className="font-display text-2xl md:text-3xl text-cream mb-3">{rule.title}</h3>
              <p className="font-body text-sm md:text-base text-[#4A3A28] leading-relaxed">{rule.body}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
